"use strict";
/**
 * Comment API Types
 *
 * Response types derived from Comment (shared-types/src/database/comment.ts).
 * Request types remain standalone (Requirement 9).
 *
 * Derivation chain:
 *   Comment → SanitizedRecord<Comment> → Pick<..., fields> & CommentExtension = CommentResponse
 *
 * Consumed by: lambda-main, lambda-secure, free-pattern-warehouse-website
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentEntityType = void 0;
var CommentEntityType;
(function (CommentEntityType) {
    CommentEntityType["PATTERN"] = "pattern";
    CommentEntityType["PROJECT"] = "project";
    CommentEntityType["MATERIAL"] = "material";
})(CommentEntityType || (exports.CommentEntityType = CommentEntityType = {}));
